import type { MCPAction } from '@/types/tool'

type DiscoveredRemoteTool = {
  remote_tool_name: string
  display_name: string
  description?: string
  input_schema?: Record<string, unknown>
}

export function buildExternalMcpConfig(input: {
  mcp_url: string
  mcp_transport: 'http_jsonrpc' | 'streamable_http'
  mcp_auth_type: 'none' | 'bearer' | 'header'
  mcp_auth_header_name: string
  mcp_auth_secret_id: string
  discovered_tools: DiscoveredRemoteTool[]
  enabled_remote_tools: string[]
}): NonNullable<NonNullable<MCPAction['http_config']>['external_mcp']> {
  return {
    managed: false,
    server_url: input.mcp_url,
    transport: input.mcp_transport,
    auth_type: input.mcp_auth_type,
    auth_header_name: input.mcp_auth_header_name || 'X-API-Key',
    auth_secret_id: input.mcp_auth_type === 'none' ? '' : input.mcp_auth_secret_id.trim(),
    remote_tools_catalog: input.discovered_tools.map((tool) => ({
      remote_tool_name: tool.remote_tool_name,
      display_name: tool.display_name || tool.remote_tool_name,
      description: tool.description || '',
      input_schema: tool.input_schema || {},
      available: true,
    })),
    enabled_remote_tools: input.enabled_remote_tools,
  }
}
